import React from 'react';
import { CloseIcon } from '../icons';
import { RegularButton } from './regular-button';
/**
 * `<BaseCloseButton />`  - Стилизация кнопки закрытия.
 *
 * @example ``` tsx
<HintCloseButton onClick={() => setIsOpen(false)} />
 * ```
 */
export const BaseCloseButton = ({
  ...props
}) => (/*#__PURE__*/React.createElement(RegularButton, {
  iconOnly: true,
  rounded: true,
  size: "s",
  variant: "pseudo",
  "aria-label": "close",
  ...props
}, /*#__PURE__*/React.createElement(CloseIcon, null)));